module.exports = __webpack_public_path__ + "img/zhongxin-big.58619192.jpg";